module.exports = __webpack_public_path__ + "static/resume-8c94ad78a1d4e5663d0b9203b2d691ae.pdf";